import { DateTime, Interval } from "luxon"

export const getMonthOptions = ({
  nextCutoffTime,
  startDate,
  terminationDate,
}: {
  nextCutoffTime: string
  startDate: string
  terminationDate?: string | null
}) => {
  if (!nextCutoffTime) {
    return []
  }

  const now = DateTime.now()
  const cutoffThisMonth = DateTime.fromISO(nextCutoffTime).set({
    month: now.month,
    year: now.year,
  })
  const terminationDateInstance = terminationDate
    ? DateTime.fromISO(terminationDate).endOf("month")
    : null
  const startDateInstance = startDate ? DateTime.fromISO(startDate).startOf("month") : null

  return Interval.fromDateTimes(now, now.plus({ months: 12 }))
    .splitBy({ month: 1 })
    .map(({ start: current }, idx) => {
      // Is disabled if it's after cutoff of the current month, or after the termination date of the engagement
      const isAfterCutoff = idx === 0 && cutoffThisMonth && now > cutoffThisMonth
      const isAfterTermination = !!terminationDateInstance && current > terminationDateInstance
      const isBeforeStartDate = !!startDateInstance && current < startDateInstance
      const disabled = isAfterCutoff || isAfterTermination || isBeforeStartDate

      return disabled
        ? null
        : {
            value: `${current.year}-${current.month.toString().padStart(2, "0")}`,
            label: current.toLocaleString({ month: "long", year: "numeric" }),
          }
    })
    .flatMap(item => (item ? [item] : []))
}
